import { gql } from "@apollo/client";


// export const getWallet = gql`
// query Wallet($filter: WalletFilter) {
//   wallet(filter: $filter) {
//     id
//     user_id
//     supplier_id
//     balance
//     points
//     deliveries
//   }
// }
// `

export const getSupplierWallets = gql`
query GetSupplierWallets($userId: ID!) {
  getSupplierWallets(user_id: $userId) {
    id
    merchant_id
    country
    wallet_type
    lock_status
    balance
    currency {
      code
      name
    }
  }
}
`

export const getTransactions = gql`
query GetTransactions($input: GetTransactionsInput!) {
  getTransactions(input: $input) {
    id
    wallet_id
    reference
    amount
    direction
    type
    status
    metadata
    created_at
    updated_at
    currency {
      code
      name
    }
  }
}
`

export const getTransaction = gql`
query GetTransaction($input: GetTransactionsInput!) {
  getTransaction(input: $input) {
    id
    wallet_id
    reference
    amount
    direction
    type
    status
    metadata
    created_at
    updated_at
    currency {
      code
      name
    }
  }
}
`

// export const getWalletSummary = gql`
// query GetSupplierWalletSummary($supplierId: ID!) {
//   getSupplierWalletSummary(supplier_id: $supplierId) {
//     balance
//     totalWithdrawals
//     totalRevenueGenerated
//     pendingPayoutRequests
//   }
// }
//   `

export const getWalletPayoutsPendingCount = gql`
query GetWalletPayoutsPendingCount($input: GetWalletPayoutsInput) {
  getWalletPayoutsCount(input: $input)
}
`;

export const getSupplierWalletWithdrawals = gql`
query GetSupplierWalletWithdrawals($input: GetTransactionsInput!) {
  getTransactions(input: $input) {
    amount
    status
  }
}
`;

export const getPayoutTransactions = gql`
query GetWalletPayouts($input: GetWalletPayoutsInput!) {
  getWalletPayouts(input: $input) {
    id
    amount
    country
    account_number
    account_name
    provider
    status
    metadata
    created_at
    currency {
      code
      name
    }
    transaction {
      id
      wallet_id
      reference
      amount
      direction
      type
      status
      metadata
      created_at
      updated_at
    }
  }
}
`;

// export const getWalletHistory = gql`
// # query WalletHistory($filter: WalletHistoryFilter, $pagination: Pagination) {
// #   walletHistoryLength(filter: $filter)
// #   walletHistory(filter: $filter, pagination: $pagination) {
// #     id
// #     status
// #     amount
// #     transaction_type
// #     previous_balance
// #     created_at
// #     reference
// #   }
// # }
// `